<template>
  <v-container class="pa-0">
    <deactivate-user v-model="showDeactivate" />

    <ValidationObserver ref="observer" v-slot="{ invalid }" v-if="this.user">
      <v-row dense>
        <v-col>
          <form autocomplete="off">
            <v-row dense>
              <v-col>
                <mb-input-text
                  v-model="user.name"
                  name="name"
                  label="Nome Completo"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col xl="4" lg="4" md="5" sm="5" cols="12">
                <mb-date
                  v-model="user.birthdate"
                  name="birthdate"
                  label="Data de Nascimento"
                  rules="required"
                  :allowedDates="(vl) => { return $moment(vl).isBefore($moment()) }"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-select
                  v-model="user.genre"
                  :items="sexItems"
                  itemText="text"
                  itemValue="vl"
                  name="sex"
                  label="Sexo"
                  rules="required"
                />
              </v-col>
              <v-col xl="4" lg="4" md="5" sm="5" cols="12">
                <mb-input-phone
                  v-model="user.phones.mobile"
                  name="phone"
                  label="Celular"
                  rules="required"
                />
              </v-col>

              <v-col xl="4" lg="4" md="5" sm="5" cols="12">
                <mb-input-cpf
                  v-model="user.cpf"
                  name="cpf"
                  label="CPF"
                  @change="() => {cpfChanged = true;}"
                  :disabled="(!user.canRemoveCpf && user.cpf) && !cpfChanged"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-input-text
                  v-model="user.email"
                  name="email"
                  label="Email"
                  rules="required|email"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-text-button name="pc_deactivate"
                  :disabled="!user.active"
                  @click="deactivate"
                  :loading="deactivateBtnLoading"
                  label="Desativar Conta"
                />
              </v-col>
              <v-col  align="right"
                xl="4" lg="4" md="4" sm="4" cols="12"
                :order="($vuetify.breakpoint.xsOnly) ? 'first' : 'last'"
              >
                <mb-text-button name="pc_save"
                  :disabled="invalid"
                  @click="save"
                  :loading="saveBtnLoading"
                  label="Salvar"
                />
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputText from '@/components/general/inputs/MbInputText';
import MbInputPhone from '@/components/general/inputs/MbInputPhone';
import MbSelect from '@/components/general/inputs/MbSelect';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbDate from '@/components/general/inputs/MbDate';
import MbInputCpf from '@/components/general/inputs/MbInputCpf';
import DeactivateUser from '@/components/cadastre/DeactivateUser';

export default {
  data: () => ({
    user: null,
    sexItems: [
      { vl: 'female', text: 'Feminino' },
      { vl: 'male', text: 'Masculino' },
    ],
    deactivateBtnLoading: false,
    saveBtnLoading: false,
    showDeactivate: false,
    cpfChanged: false,
  }),
  created() {
    this.user = Object.assign({}, this.$store.getters['auth/getUser']);
    this.setPhones(this.user.phones);
  },
  methods: {
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.saveBtnLoading = true;
        const userUpdated = Object.assign({}, this.user);
        delete userUpdated.since;
        delete userUpdated.verified;
        delete userUpdated.active;
        delete userUpdated.avatar;
        delete userUpdated.updatedAt;

        this.$store
          .dispatch('patientUser/update', userUpdated)
          .then(() => {
            bus.$emit('message', {
              message: 'Usuário atualizado com sucesso!',
              type: 'success',
            });
            this.cpfChanged = false;
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
    deactivate() {
      this.showDeactivate = true;
    },
    setPhones(phones) {
      if (typeof phones === 'string') {
        const phonesObj = JSON.parse(phones);
        this.user.phones = { home: null, mobile: null };
        this.user.phones.home = phonesObj.home || null;
        this.user.phones.mobile = phonesObj.mobile || null;
      } else {
        this.user.phones.home = null;
        this.user.phones.mobile = null;
      }
    },
  },
  components: {
    ValidationObserver,
    MbInputText,
    MbInputPhone,
    MbTextButton,
    MbSelect,
    MbDate,
    MbInputCpf,
    DeactivateUser,
  },
};
</script>
